/// <reference lib="dom" />
// Web shim for react-native-image-picker
// On web, image picking is handled via <input type="file"> natively in the browser.
// This shim provides the same API surface so the module resolves without errors.

import { ImageLibraryOptions, ImagePickerResponse, CameraOptions } from 'react-native-image-picker';

export const launchImageLibrary = (
  _options: ImageLibraryOptions,
  callback?: (response: ImagePickerResponse) => void,
): Promise<ImagePickerResponse> => {
  return new Promise(resolve => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    input.onchange = () => {
      const file = input.files?.[0];
      if (!file) {
        const res: ImagePickerResponse = { didCancel: true };
        callback?.(res);
        resolve(res);
        return;
      }
      const uri = URL.createObjectURL(file);
      const res: ImagePickerResponse = {
        didCancel: false,
        assets: [{ uri, fileName: file.name, type: file.type, fileSize: file.size }],
      };
      callback?.(res);
      resolve(res);
    };
    input.click();
  });
};

export const launchCamera = (
  _options: CameraOptions,
  callback?: (response: ImagePickerResponse) => void,
): Promise<ImagePickerResponse> => {
  // Camera access not supported in this web build; fall back to library
  return launchImageLibrary(_options as ImageLibraryOptions, callback);
};

export type { MediaType, ImagePickerResponse } from 'react-native-image-picker';
